import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@dc-shared-web/components/shadcn/toast'
import { useToast } from '@dc-shared-web/components/shadcn/use-toast'
import { VssToaster } from '@dc-shared-web/components/base/VssToaster'

export function Toaster({ position = 'top' }: { position?: 'top' | 'bottom' }) {
  const { toasts } = useToast()

  if (typeof window !== 'undefined' && window.__VSS_UPDATES__?.toastEnabled) {
    return <VssToaster position={position} />
  }

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast data-testid='toast-message' key={id} {...props}>
            <div className='tw-grid tw-gap-1'>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport position={position} />
    </ToastProvider>
  )
}
